/**
 * Accessibility enhancements for product option groups not controlled by theme Liquid
 * (e.g. LinkedOption combined listings app blocks).
 */
(function () {
  'use strict';

  function getLinksContainer(block) {
    var links = block.querySelectorAll('a[href]');
    if (links.length < 2) return null;

    var container = links[0].parentElement;
    while (container && container !== block) {
      if (container.querySelectorAll('a[href]').length === links.length) {
        return container;
      }
      container = container.parentElement;
    }

    return links[0].parentElement;
  }

  function getGroupLabel(block, container) {
    var child = block.firstElementChild;
    while (child) {
      if (
        child !== container &&
        !container.contains(child) &&
        !child.contains(container)
      ) {
        var text = (child.textContent || '').trim();
        if (text && !child.querySelector('a[href]')) {
          return child;
        }
      }
      child = child.nextElementSibling;
    }

    var label = block.querySelector('label, legend');
    if (label && !container.contains(label)) {
      return label;
    }

    return null;
  }

  function enhanceBlock(block, index) {
    if (block.dataset.a11yGrouped === 'true') return;

    var container = getLinksContainer(block);
    if (!container || container.getAttribute('role') === 'group') return;

    var labelEl = getGroupLabel(block, container);
    container.setAttribute('role', 'group');

    if (labelEl) {
      if (!labelEl.id) {
        labelEl.id = 'product-option-group-label-' + index;
      }
      container.setAttribute('aria-labelledby', labelEl.id);
    } else {
      container.setAttribute('aria-label', 'Product options');
    }

    block.dataset.a11yGrouped = 'true';
  }

  function enhanceLinkedOptionGroups(root) {
    root = root || document;
    var index = 0;

    root.querySelectorAll('.product-single__box__block').forEach(function (block) {
      enhanceBlock(block, index);
      index += 1;
    });
  }

  function init() {
    enhanceLinkedOptionGroups();

    if (typeof MutationObserver === 'undefined') return;

    var productInfo = document.querySelector('.product-info');
    if (!productInfo) return;

    var observer = new MutationObserver(function () {
      enhanceLinkedOptionGroups(productInfo);
    });

    observer.observe(productInfo, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
